module.exports = __webpack_public_path__ + "img/waterIcon.2cdc45d5.png";